export default __webpack_public_path__ + "static/media/got.1902b8ca.jpg";